import React, { createContext } from 'react';
import './main.scss';
import AppRouter from './router/AppRouter';
import ConfirmModal from './utility/ConfirmModal';
import AlertModal from './utility/AlertModal';
import AntdNotification from 'utility/AntdNotification';
import locale from 'antd/locale/zh_TW';
import { ConfigProvider } from 'antd';
import { MsalProvider } from '@azure/msal-react';

export const LocaleContext = createContext();

const App = ({ instance }) => {
  return (
    <MsalProvider instance={instance}>
      <ConfigProvider locale={locale}>
        <AppRouter />
        <ConfirmModal />
        <AlertModal />
        <AntdNotification />
      </ConfigProvider>
    </MsalProvider>
  );
};

export default App;
